<div class="cb-body__wrap">
    <div class="cb-body__content">
        <!-- Account section -->
        <template v-if="!editMode && skip_cart">
            <cart-fixed :edit-order = "true" :nav-icon = "'right'"></cart-fixed>
        </template>
        <slot></slot>
        <div class="cb-section" @keyup.enter="submit()">
            <template v-for="(arr,index) in config_in_twos">
        <div v-if="arr.length == 2" class="cb-field__group" :class="[{'cb-field--top': index == 0},{'cb-field--bottom': (config_in_twos.length-1) == index}]">
          <component class="cb-field__left" @informError="informError(index, 0)" :siblingError="showSiblingError(index, 1)" @clearError="clearError(index, 0)" :is="componentName(arr[0].type)" :name="arr[0].name" v-if="arr[0].type">
          </component>
          <component class="cb-field__right" @informError="informError(index, 1)" @clearError="clearError(index, 1)" :siblingError="showSiblingError(index, 0)" :is="componentName(arr[1].type)" :name="arr[1].name" v-if="arr[1].type">
          </component>
        </div>
        <div :class="[{'cb-field--top': index == 0},{'cb-field--bottom': (config_in_twos.length-1) == index}]" v-else-if="arr.length == 1 && arr[0].type!= 'hidden'" class="cb-field__group">
          <component :is="componentName(arr[0].type)" :name="arr[0].name" v-if="arr[0].type">
          </component>
        </div>
      </template>
        </div>
    </div>
    <div class="cb-body__footer">
        <cb-notes :custom-class="'cb-section'" :type="'info'" :message="accountNote"></cb-notes>
        <cb-button :custom-class="'primary'" @next="submit()" :show-loader="showLoader">
            <!-- Todo sample -->
            <!-- <div slot="note" class="cb-note__content">
        You will not be charged until the end of your trial period.
      </div> -->
            {{buttonTxt}}
        </cb-button>
    </div>
</div>